import {
  Loaders,
  createUseLoad,
  createLoaderObject,
  GetLoadParamMap,
  GetLoadResultMap,
  createMutationHookObject,
  loadersAsMutations,
} from 'entities/_config';

import { authLoaders } from './auth/loaders';
import { usersLoaders } from './users/loaders';
import { wppLoaders } from './whatsapp/loaders';
import { surveyLoaders } from './surveys/loaders';
import { infraLoaders } from './infra/load';

// enforce intellisense and permission <> key
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildLoaders<AppLoaders extends Record<string, Loaders<any>>>(
  loaders: AppLoaders,
): AppLoaders {
  return loaders;
}

const entityLoaders = buildLoaders({
  auth: authLoaders,

  users: usersLoaders,

  whatsapp: wppLoaders,

  surveys: surveyLoaders,

  infra: infraLoaders,
});

export type EntityLoaders = typeof entityLoaders;

export const useLoad = createUseLoad(entityLoaders);

export const loaders = createLoaderObject(entityLoaders, useLoad);

export type LoadParams = GetLoadParamMap<EntityLoaders>;

export type LoadResults = GetLoadResultMap<EntityLoaders>;

export const loadActions = createMutationHookObject(loadersAsMutations(entityLoaders));
